/**
 * Declarative feature gating. Renders children only when the tenant's real subscription
 * (its plan's features, plus any admin override) includes the feature; otherwise renders
 * `fallback` (or nothing).
 *
 *   <FeatureGate feature="analytics.dashboards" fallback={<UpgradePrompt />}>
 *     <AdvancedAnalytics />
 *   </FeatureGate>
 */
import { type ReactNode } from 'react'
import { type Feature } from './plans'
import { useFeature } from './SubscriptionContext'

export function FeatureGate({
  feature,
  children,
  fallback = null,
}: {
  feature: Feature
  children: ReactNode
  fallback?: ReactNode
}) {
  const enabled = useFeature(feature)
  return <>{enabled ? children : fallback}</>
}

export default FeatureGate
